import { Controller, type ControllerProps, type FieldValues } from 'react-hook-form';
import { Box, Button, ButtonProps, styled, Typography, CircularProgress } from '@mui/material';

type ButtonType = { name: string; loading?: boolean } & ButtonProps;

type Props<T extends FieldValues> = {
  title: string;
  input: ControllerProps<T>;
  buttons: ButtonType[];
};

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
}));

const Main = styled(Box)(() => ({
  flex: 1,
  paddingTop: 20,
  paddingInline: 16,
  gap: '10vh',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const Footer = styled(Box)(() => ({
  gap: 12,
  paddingInline: 16,
  display: 'flex',
  flexDirection: 'column',
  width: '-webkit-fill-available',
  alignItems: 'center',
}));

export default function AuthForm<T extends FieldValues>({ title, input, buttons }: Props<T>) {
  return (
    <Container>
      <Main>
        <Typography
          fontSize={24}
          fontWeight={700}
          lineHeight="28px"
          whiteSpace="pre-line"
          textAlign="center"
          color="#9C9FA3"
          sx={{ textDecoration: 'none' }}
        >
          {title}
        </Typography>
        <Controller {...input} />
      </Main>
      <Footer>
        {buttons.map(({ id, name, loading, ...rest }) => (
          <Button
            key={id}
            {...rest}
            variant="contained"
            size="large"
            sx={{ maxWidth: 600, width: '100%' }}
            startIcon={loading && <CircularProgress size={16} color="inherit" />}
          >
            {name}
          </Button>
        ))}
      </Footer>
    </Container>
  );
}
